import React from 'react';
import { useRefresh } from '../contexts/RefreshContext';

const RefreshButton = ({ className = '', size = 'md' }) => {
  const { refresh, isRefreshing } = useRefresh();

  const sizeClasses = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-12 h-12'
  };

  return (
    <button
      onClick={refresh}
      disabled={isRefreshing}
      className={`
        ${sizeClasses[size]}
        flex items-center justify-center
        bg-blue-600 hover:bg-blue-700 
        disabled:bg-blue-400 disabled:cursor-not-allowed
        text-white rounded-full shadow-lg
        transition-all duration-200
        ${isRefreshing ? 'animate-spin' : ''}
        ${className}
      `}
      title={isRefreshing ? 'Refreshing...' : 'Refresh'}
    >
      <svg 
        className={`w-5 h-5 ${isRefreshing ? 'animate-spin' : ''}`}
        fill="none" 
        stroke="currentColor" 
        viewBox="0 0 24 24"
      >
        <path 
          strokeLinecap="round" 
          strokeLinejoin="round" 
          strokeWidth={2} 
          d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" 
        />
      </svg>
    </button>
  );
};

export default RefreshButton;

